import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {
    roles: [],
    groups: [],
    profile: {},
    atlasGroups: [],
    permissions: [],
    email: "",
    isAdmin: false,
  },
  status: "idle",
  error: null,
};

const loadingStates = {
  IDLE: "idle",
  GETTING: "getting",
  SAVING: "saving",
  DELETING: "deleting",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    addUserEmail: (state, action) => {
      state.user.email = action.payload;
    },
    addUserGroups: (state, action) => {
      state.user.groups = action.payload;
    },
    resetUserStatus: (state) => {
      state.status = loadingStates.IDLE;
    },
    addUserRoles: (state, action) => {
      state.user.roles = action.payload;
    },
    addUserPermissions: (state, action) => {
      state.user.permissions = action.payload;
    },
    addIsAdmin: (state, action) => {
      state.user.isAdmin = action.payload;
    },
    addUserAtlasGroups: (state, action) => {
      state.user.atlasGroups = action.payload;
    },
    addUserProfile: (state, action) => {
      state.user.profile = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  addUserEmail,
  addUserGroups,
  resetUserStatus,
  addUserRoles,
  addUserPermissions,
  addIsAdmin,
  addUserAtlasGroups,
  addUserProfile,
} = userSlice.actions;

export default userSlice.reducer;

export const selectUserEmail = (state) => state.user.user.email;
export const selectUserGroups = (state) => state.user.user.groups;
export const selectUserRoles = (state) => state.user.user.roles;
export const selectRoleById = (state, roleId) =>
  state.roles.roles.find((role) => role.id === roleId);
